import React from 'react';
import { Input } from 'reactstrap';

export const PhoneInputInput = React.forwardRef((props, ref) => (
	<Input type="tel" {...props} innerRef={ref} />
));
